<a
  class="ac-message cf-flex cf-flex-row cf-gap-8 cf-align-items-center"
  [routerLink]="routerLink"
  [queryParams]="routerLinkParams"
  [ngClass]="{
    error: level === 0,
    warning: level === 1,
    info: level === 2,
    'child-message': isChildMessage(parentEntity)
  }"
>
  <ng-content></ng-content>
</a>
